module.exports = __webpack_public_path__ + "static/img/72.14b2893.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Teams/72.png
// module id = fsq2
// module chunks = 1